import { IconBolt } from "@tabler/icons-react";
import { Text } from "../../../../components/common/typography";
import { IconPill } from "../../../../components/common/icon-pill";
import type { LoyaltyPromotionDto } from "../../../../api";

interface LoyaltyPromoBannerProps {
  promotion: LoyaltyPromotionDto;
}

const fmtMult = (m: number) => `${m % 1 === 0 ? m.toFixed(0) : m.toFixed(1)}×`;
const fmtEnds = (v: string | null | undefined) =>
  v ? new Date(v).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : null;

/**
 * Prominent product-page banner announcing an active loyalty promotion and when
 * it ends. Rendered only when the product has an active multiplier > 1.
 */
export function LoyaltyPromoBanner({ promotion }: LoyaltyPromoBannerProps) {
  const ends = fmtEnds(promotion.endsAt);
  return (
    <div className="flex items-center gap-3 rounded-2xl border border-accentGreenTint bg-accentGreenTintBg px-4 py-3">
      <IconPill size={36} tone="gradient" shape="square">
        <IconBolt size={20} />
      </IconPill>
      <div className="flex min-w-0 flex-col">
        <Text variant="bodyBold" tone="dark">
          Earn {fmtMult(promotion.multiplier)} loyalty points
        </Text>
        <Text variant="bodyXs" tone="muted">
          {promotion.name}
          {ends ? ` · ends ${ends}` : ""}
        </Text>
      </div>
    </div>
  );
}
